import React from "react";
import { motion } from "framer-motion";

export default function SimplePage({ title }: { title: string }) {
  return (
    <div className="container px-6 py-14 md:px-12 md:py-16">
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-3xl"
      >
        <h1 className="text-3xl md:text-4xl font-bold tracking-tight m-0">
          {title}
        </h1>
        <p className="mt-3 text-base md:text-lg leading-relaxed text-[var(--muted)]">
          Content coming soon.
        </p>
        <div className="mt-8 h-px w-full bg-black/10" />
      </motion.div>
    </div>
  );
}
